import { Controller as BaseController } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export class Controller extends BaseController {
  static targets = ['filter']

  connect() {
    this.element[this.identifier] = this
    useDispatch(this)
  }

  clearAll() {
    this.filterTargets.forEach((elem) => elem.filter.clearAll(false))
    this.dispatch('filtersCleared')
  }
}
